import '../styles/components/Loader.scss';

function Loader() {
  return (
    <div className='Loader'>
      <div className='loader'>
      </div>
    </div>
  )
}

export default Loader
